/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a UUID and can two ever match?`)
};

const es_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es un UUID y pueden dos coincidir alguna vez?`)
};

const de_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine UUID und können zwei jemals übereinstimmen?`)
};

const nl_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een UUID en kunnen twee ooit overeenkomen?`)
};

const fr_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'un UUID et deux peuvent-ils jamais se correspondre ?`)
};

const it_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un UUID e due possono mai coincidere?`)
};

const pt_br2_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um UUID e dois podem corresponder?`)
};

const pt_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um UUID e podem dois alguma vez coincidir?`)
};

const ja_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDとは何で、2つが一致することはありますか？`)
};

const zh_rg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是UUID？两个UUID会重复吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_faq2_q", locale)
	if (locale === "en") return en_rg_faq2_q(inputs)
	if (locale === "es") return es_rg_faq2_q(inputs)
	if (locale === "de") return de_rg_faq2_q(inputs)
	if (locale === "nl") return nl_rg_faq2_q(inputs)
	if (locale === "fr") return fr_rg_faq2_q(inputs)
	if (locale === "it") return it_rg_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_rg_faq2_q(inputs)
	if (locale === "pt") return pt_rg_faq2_q(inputs)
	if (locale === "ja") return ja_rg_faq2_q(inputs)
	return zh_rg_faq2_q(inputs)
};